import { useState } from 'react';
import './FAQAccordion.scss';

function FAQAccordion({
  tag,
  title,
  items = [],
  allowMultiple = false,
  className = '',
}) {
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggle = (index) => {
    if (allowMultiple) {
      setOpenIndexes((prev) =>
        prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
      );
    } else {
      setOpenIndexes((prev) => (prev.includes(index) ? [] : [index]));
    }
  };

  return (
    <section className={`faq ${className}`}>
      <div className="faq__container">
        {(tag || title) && (
          <div className="faq__header">
            {tag && <span className="faq__tag">{tag}</span>}
            {title && <h2 className="faq__title">{title}</h2>}
          </div>
        )}

        <div className="faq__list">
          {items.map((item, i) => {
            const isOpen = openIndexes.includes(i);
            return (
              <div key={i} className={`faq__item ${isOpen ? 'faq__item--open' : ''}`}>
                <button className="faq__question" onClick={() => toggle(i)}>
                  <span>{item.question}</span>
                  <span className="faq__icon">+</span>
                </button>
                <div className="faq__answer">
                  <div className="faq__answer-inner">{item.answer}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FAQAccordion;
